import Masonry from 'masonry-layout';
import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  masonry;

  static targets = ['gallery'];

  connect() {
    super.connect();

    this.lightGallery;

    this.defaultOptions;

    this.masonry = new Masonry(this.galleryTarget, {
      itemSelector: '.c-gallery__item',
      columnWidth: '.c-gallery__sizer',
      gutter: 20
    });
  }

  get defaultOptions() {
    return {
      // Your default options here
    }
  }

  disconnect() {
    this.masonry?.destroy();
    this.masonry = undefined;
  }
}
